import React from 'react'
import { Button, ListGroup, Modal } from 'react-bootstrap';

const ViewCategoryModal = ({ viewShowModal, setViewShowModal, categoryidList,config }) => {
    const {
        title,
        fetchListApi,
        fetchSelectListApi,
        fetchByIdApi,
        fetchCreateApi,
        userCategoryApi,
        categorySelectKey,
        fetchUpdate,
        addModal: AddModal,
        viewModal: ViewModal,
        updateModal: UpdateModal,
        categoryIdField,
        CategoryOptions,
        categoryLabel
    } = config;

   
   const getCategoryLabelFromId = (config, selectId) => {
  if (!config || !config.CategoryOptions) {
    return "N/A";
  }

  const selectedOption = config.CategoryOptions.find(option => option.id === selectId);
  return selectedOption?.main_category_name || "N/A";
};
    return (
        <Modal className="fade" show={viewShowModal}>
            <Modal.Header>
                <Modal.Title>View Category</Modal.Title>
                <Button
                    variant=""
                    className="btn-close"
                    onClick={() => setViewShowModal(false)}
                >

                </Button>
            </Modal.Header>
            <Modal.Body>
                <div className="basic-list-group">
                    <ListGroup>

                        <ListGroup.Item
                            className="d-flex justify-content-between align-items-center"

                        >
                            <div>
                                <ul>
                                     {config.viewTitle?.map((header, index) => (
                                                    <li key={index} className="list_of_client">{header}</li>
                                                ))}
                                    {/* <li className="list_of_client">Category Name</li>
                                    <li className="list_of_client">Parent Category</li>
                                    <li className="list_of_client">Slug</li>
                                    <li className="list_of_client">Status</li> */}
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li className="mb-2">{categoryidList?.category_name || "N/A"}</li>
                                    {/* <li className="mb-2">{categoryidList?.user_category_main_id || "N/A"}</li> */}
                                    {getCategoryLabelFromId(categoryidList?.user_category_main_id)}
                                    <li className="mb-2">{categoryidList?.slug || "N/A"}</li>
                                    <li className="mb-2">
                                        {categoryidList?.active_status === "1"
                                            ? "Active"
                                            : categoryidList?.active_status === "0"
                                                ? "InActive"
                                                : "N/A"}
                                    </li>
                                </ul>

                            </div>


                        </ListGroup.Item>

                    </ListGroup>
                </div>
            </Modal.Body>

        </Modal>
    )
}

export default ViewCategoryModal